import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import FlowEdit from "../../assets/Header/FlowEdit.svg";
import dashboardIcon from "../../assets/Sidebar/dashboard-icon.svg";
import dashboardActiveIcon from "../../assets/Sidebar/dashboardActive.svg";
import guidelinesIcon from "../../assets/Sidebar/guidelines.svg";
import guidelinesActiveIcon from "../../assets/Sidebar/guidelinesActive.svg";
import downloadActive from "../../assets/Sidebar/downloadActive.svg";
import downloadIcon from "../../assets/Sidebar/downloadIcon.svg";
import reviewIcon from "../../assets/Sidebar/review.svg";
import reviewActive from "../../assets/Sidebar/reviewActive.svg";
import seggregationIcon from "../../assets/Sidebar/seggregation.svg";
import seggregationActive from "../../assets/Sidebar/seggregationActive.svg";
import { Link, useLocation, useParams } from "react-router-dom";
import toggleIcon from "../../assets/Sidebar/toggle.svg";
import { Tooltip } from "antd";
import useAuthContext from "../../hooks/useAuthContext";
import { storedIsInternal } from "../../components/Admin/helpers";
import { useLogoutUser } from "../../hooks/useSeggregation";
import { SeggreagtionContext } from "../../context/seggregationProvider";
import { SourceProviderContext } from "../../context/sourceProvider";

const Sidebar = ({ handleToggle }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const {
    user: { isInternal, isSourceAdmin },
  } = useAuthContext();
  const { sourceData } = useContext(SourceProviderContext);
  const location = useLocation();
  const { segg_logoutPayload, segg_setLogoutPayload } =
    useContext(SeggreagtionContext);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600 && window.innerWidth <= 700) {
        setSidebarToggle(true);
      } else {
        setSidebarToggle(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const allLinks = [
    {
      id: 1,
      title: "Dashboard",
      icon: dashboardIcon,
      activeIcon: dashboardActiveIcon,
      href: "/order-list",
      isActive: true,
    },
    {
      id: 2,
      title: "Guidelines Creation",
      icon: guidelinesIcon,
      activeIcon: guidelinesActiveIcon,
      href: "/",
      isActive: false,
    },
    {
      id: 3,
      title: "Guidelines",
      icon: guidelinesIcon,
      activeIcon: guidelinesActiveIcon,
      href: "/view-guidelines",
      isActive: false,
    },
    {
      id: 4,
      title: "Review",
      icon: reviewIcon,
      activeIcon: reviewActive,
      href: "/review-batch-list",
      isActive: false,
    },
    {
      id: 5,
      title: "Segregation",
      icon: seggregationIcon,
      activeIcon: seggregationActive,
      href: "/seggregation-batch-list?activeProfile=batch",
      isActive: false,
    },
    {
      id: 9,
      title: "Batches (Admin)",
      icon: dashboardIcon,
      activeIcon: dashboardActiveIcon,
      href: "/admin/batches",
      isActive: false,
    },
    {
      id: 10,
      title: "BST2 Dashboard",
      icon: dashboardIcon,
      activeIcon: dashboardActiveIcon,
      href: "/bst2-dashboard",
      isActive: false,
      internalOnly: true,
    },
    {
      id: 6,
      title: "Request",
      icon: seggregationIcon,
      activeIcon: seggregationActive,
      href: "/requests",
      isActive: false,
    },
    {
      id: 7,
      title: "Admin",
      icon: seggregationIcon,
      activeIcon: seggregationActive,
      href: "/users-list",
      isActive: false,
    },
    {
      id: 8,
      title: "Download",
      icon: downloadIcon,
      activeIcon: downloadActive,
      href: "/download",
      isActive: false,
    },
  ];
  const isInternalUser = Boolean(isInternal || storedIsInternal());

  const filterSidebarLinks = () => {
    if (isInternalUser) {
      return allLinks.filter(
        (link) =>
          (!link.internalOnly || isInternalUser) &&
          (isSourceAdmin || link.id !== 7)
      );
    }
    return allLinks.filter(
      (link) =>
        !link.internalOnly &&
        (((link.id === 1 || link.id === 3 || link.id === 8) &&
          (isSourceAdmin || link.id !== 7)) ||
          (!sourceData?.featureFlag?.disableReviewPortal && link.id === 4))
    );
  };

  const [links, setLinks] = useState(filterSidebarLinks);

  useEffect(() => {
    setLinks(filterSidebarLinks());
  }, [isInternalUser, isSourceAdmin, sourceData?.featureFlag?.disableReviewPortal]);
  useEffect(() => {
    const dashboardPaths = [
      "/upload-images/",
      "/select-marketplace/",
      "/sequencing/",
      "/add-on-services/",
      "/sku-list/",
      "/order-summary/",
      "/success",
      "/billing",
    ];
    const updatedLinks = links.map((link) => {
      if (
        link.id === 1 &&
        dashboardPaths.some((path) => location?.pathname?.includes(path))
      ) {
        return { ...link, isActive: true };
      }
      if (
        link.id === 2 &&
        (location?.pathname?.includes("/create-set") ||
          location?.pathname?.includes("/update-set"))
      ) {
        return { ...link, isActive: true };
      }
      if (
        link.id === 4 &&
        (location?.pathname?.includes("/review-sku-list/") ||
          location?.pathname?.includes("/review-detail/"))
      ) {
        return { ...link, isActive: true };
      }
      if (
        link.id === 5 &&
        (location?.pathname?.includes("/seggregation-batch-list") ||
          location?.pathname?.includes("/select-category/") ||
          location?.pathname?.includes("/select-variant/") ||
          location?.pathname?.includes("/sequence-variant/") ||
          location?.pathname?.includes("/select-add-on/") ||
          location?.pathname?.includes("/bst-seggregation/"))
      ) {
        return { ...link, isActive: true };
      }
      if (
        link.id === 9 &&
        location?.pathname?.includes("/admin/batches")
      ) {
        return { ...link, isActive: true };
      }
      if (link.id === 10 && location?.pathname?.includes("/bst2-dashboard")) {
        return { ...link, isActive: true };
      }
      return { ...link, isActive: location?.pathname === link?.href };
    });
    setLinks(updatedLinks);
  }, [location.pathname]);

  const handleLinkClick = (clickedId) => {
    const clickedLink = links?.find((link) => link?.id === 5);
    if (clickedLink?.id === 5 && clickedLink.isActive) {
      logoutUser(segg_logoutPayload);
    }
    const updatedLinks = links.map((link) =>
      link?.id === clickedId
        ? { ...link, isActive: true }
        : { ...link, isActive: false }
    );

    setLinks(updatedLinks);
  };
  const onSuccess = (res) => {
    if (res.status === 200) {
      segg_setLogoutPayload("");
    }
  };
  const { mutate: logoutUser } = useLogoutUser(onSuccess);

  const getSmallSideBarContent = () => {
    return (
      <div className="small_sidebar_content">
        <div className="upper_section">
          {links.map((content) => (
            <div className={content.isActive ? "active" : ""} key={content?.id}>
              <Link
                to={content.href}
                onClick={() => handleLinkClick(content?.id)}
              >
                <Tooltip title={content.title} placement="rightTop">
                  <img
                    src={content.isActive ? content.activeIcon : content.icon}
                    alt={content.title}
                  />
                </Tooltip>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const getSideBarContent = () => {
    return (
      <div className="sidebar_container">
        <div className="logo_container">
          <div className="logo_wrapper">
            <img src={FlowEdit} alt="logo" />
          </div>
        </div>
        <div className="links_container">
          <div className="links_content">
            {links.map((link) => (
              <div className={link.isActive ? "active" : ""} key={link?.id}>
                <Link to={link.href} onClick={() => handleLinkClick(link?.id)}>
                  <img
                    src={link.isActive ? link.activeIcon : link.icon}
                    alt={link.title}
                  />
                  {link.title}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const getToggleButton = () => {
    return (
      <div
        onClick={handleSidebar}
        className={`toggle_sidebar_button ${
          sidebarToggle ? "small_toggle_sidebar" : ""
        }`}
      >
        <img
          src={toggleIcon}
          alt="sidebarButton"
          className={`toggle_image ${sidebarToggle ? "rotate" : ""}`}
        />
      </div>
    );
  };

  const handleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
    handleToggle();
  };

  return (
    <div className="sidebar_section">
      {getToggleButton()}
      {!sidebarToggle ? getSideBarContent() : getSmallSideBarContent()}
    </div>
  );
};

export default Sidebar;
